import { FC } from 'react';
import { Box, Center, Image } from '@chakra-ui/react';

import magGlass from 'assets/brand/mag-glass@2x.png';
import Text from 'components/_core/Text';

import locales from './locales';

const NoFilteredRequestsView: FC = () => (
  <Center flexDirection="column">
    <Box boxSize="5rem" paddingBottom="space-28">
      <Image alt="" role="presentation" src={magGlass} />
    </Box>

    <Box paddingBottom="space-4">
      <Text fontWeight="weight-500" size="lg" variant="primary">
        {locales.title}
      </Text>
    </Box>

    <Box paddingBottom="space-16">
      <Text>{locales.description}</Text>
    </Box>
  </Center>
);

export default NoFilteredRequestsView;
